import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import DashboardContent from '../../dashboardWrapper/DashboardContent';
import Wrapper from '../../dashboardWrapper/Wrapper';
import Avatar from './avatar/Avatar';
import Cover from './cover/Cover';

const DashboardCompanyManagement = () => {
  const {t} = useTranslation();

  return (
    <Wrapper>
        <DashboardContent>
            <DashboardMainTitle> مدیریت غرفــه </DashboardMainTitle>
            <Tabs defaultActiveKey="avatar">
                    <Tab eventKey="avatar" title={t("profile photo")} className='dashboard_tab'>
                        <Avatar />
                    </Tab>
                    <Tab eventKey="cover" title={t("profile cover")} className='dashboard_tab'>
                        <Cover />
                    </Tab>
                </Tabs>
        </DashboardContent>
    </Wrapper> 
  )
};

export default DashboardCompanyManagement;
